import React, { useState, useEffect } from 'react'
import { Panel, Grid, Row, Col } from 'rsuite'
import CKEditorFrom from '../../../../components/forms/input/CKEditorFrom'
import RadioForm from '../../../../components/forms/radioForm/RadioForm'
import AttachFilesForm from '../../../attachfiles/AttachFilesForm'
import AttachFilesWidget from '../../../attachfiles/AttachFilesWidget'
import Form9AttachFilesWidget from './Form9AttachFilesWidget'

export default function BackgroundForm9Form({
  schema: _schema,
  register,
  errors,
  Controller,
  control,
  setValue,
  clearErrors,
  getValues,
}) {
  const [schema, setSchema] = useState(_schema)

  useEffect(() => {
    // acts.
  }, [schema])

  return (
    <>
      <Panel header="">
        <Grid fluid>
          <Row>
            {schema.backgroundDescription && (
              <Col>
                <CKEditorFrom
                  schema={schema.backgroundDescription}
                  register={register}
                  Controller={Controller}
                  control={control}
                  errors={errors}
                  setValue={setValue}
                  clearErrors={clearErrors}
                />
              </Col>
            )}

            {schema.generalAreaInformation && (
              <Col>
                <CKEditorFrom
                  schema={schema.generalAreaInformation}
                  register={register}
                  Controller={Controller}
                  control={control}
                  errors={errors}
                  setValue={setValue}
                  clearErrors={clearErrors}
                />
              </Col>
            )}

            {schema.rootCauseAnalys && (
              <Col>
                <CKEditorFrom
                  schema={schema.rootCauseAnalys}
                  register={register}
                  Controller={Controller}
                  control={control}
                  errors={errors}
                  setValue={setValue}
                  clearErrors={clearErrors}
                />
              </Col>
            )}

            {schema.problemLevel && (
              <Col>
                <div style={{ paddingTop: 10 }}>
                  <RadioForm
                    schema={schema.problemLevel}
                    register={register}
                    Controller={Controller}
                    control={control}
                    errors={errors}
                    setValue={setValue}
                    clearErrors={clearErrors}
                    otherKey="problemLevelOther"
                    selectedOther={
                      schema.problemLevel.value && schema.problemLevel.value[0] == '99'
                    }
                    otherValue={schema.problemLevelOther}
                    value={schema.problemLevel.value && schema.problemLevel.value[0]}
                  />
                </div>
              </Col>
            )}

            {schema.problemSolve && (
              <Col>
                <CKEditorFrom
                  schema={schema.problemSolve}
                  register={register}
                  Controller={Controller}
                  control={control}
                  errors={errors}
                  setValue={setValue}
                  clearErrors={clearErrors}
                />
              </Col>
            )}

            {schema.problemSolution && (
              <Col>
                <div style={{ paddingTop: 10 }}>
                  <RadioForm
                    schema={schema.problemSolution}
                    register={register}
                    Controller={Controller}
                    control={control}
                    errors={errors}
                    setValue={setValue}
                    clearErrors={clearErrors}
                    otherKey="problemSolutionOther"
                    selectedOther={
                      schema.problemSolution.value && schema.problemSolution.value[0] == '99'
                    }
                    otherValue={schema.problemSolutionOther}
                    value={schema.problemSolution.value && schema.problemSolution.value[0]}
                  />
                </div>
              </Col>
            )}
          </Row>
          <Row>
            {schema.attachment && (
              <Col>
                <div style={{ paddingTop: 10 }}>
                  <Form9AttachFilesWidget schema={schema.attachment} isEdit />
                </div>
              </Col>
            )}
          </Row>
        </Grid>
      </Panel>
    </>
  )
}
